import { render, staticRenderFns } from "./MyDevelopement.vue?vue&type=template&id=16f5a39a&scoped=true&"
import script from "./MyDevelopement.vue?vue&type=script&lang=ts&"
export * from "./MyDevelopement.vue?vue&type=script&lang=ts&"
import style0 from "./MyDevelopement.vue?vue&type=style&index=0&id=16f5a39a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f5a39a",
  null
  
)

export default component.exports